import Swiper from "swiper";
import { Navigation, Autoplay } from 'swiper/modules';

new Swiper(".clientSwiper", {
	slidesPerView: "auto",
	spaceBetween : 30,
	modules      : [Navigation, Autoplay],
	grabCursor   : false,
	autoplay     : {
		delay               : 3000,
		disableOnInteraction: true,
	},
	navigation   : {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});
